import styleInject from './node_modules-style-inject-dist-style-inject.es.js';

var css_248z = "/**\n * Do not edit directly\n * Generated on Mon, 15 Sep 2025 16:58:25 GMT\n */\n.chat-feedback-button.active {\n  background-color: var(--swan-sem-color-bg-action-active);\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=src-components-EndChatPage-EndChatFeedback.styles.scss.js.map
